export default __webpack_public_path__ + "static/media/slider1en.13c11961.jpg";